'use client';

import React, { useState } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { ButtonLink } from '@depop/web-ui-kit/ButtonLink';
import { Modal } from '@depop/web-ui-kit/Modal';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { FeedbackModal } from '../FeedbackModal';

import styles from './styles.module.css';

import { FeedbackStars } from '@/components/FeedbackStars';

type Props = {
  rating: number;
  count: number;
  sellerUsername: string;
  sellerId: number;
  className?: string;
};

export function Feedback({
  rating,
  count,
  sellerUsername,
  sellerId,
  className = '',
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations('common');

  return (
    <>
      <ButtonLink
        type="button"
        className={clsx(styles.feedbackButton, className)}
        onClick={() => setIsOpen(true)}
        aria-haspopup="dialog"
        role="button"
      >
        <FeedbackStars rating={rating} size="sm" />
        <Caption variant="sm-bold" as="div">
          ({count})
        </Caption>
      </ButtonLink>
      <Modal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={t('FeedbackFor', { username: sellerUsername })}
        content={() => (
          <FeedbackModal sellerId={sellerId} sellerUsername={sellerUsername} />
        )}
        wide
      />
    </>
  );
}
